import React, { useState, useEffect } from "react";
import PatientForm from "./PatientForm";
import OTPVerification from "./OTPVerification";
import BookingsTab from "./BookingsTab";
import { fetchPatientByPhone, fetchMasterLists } from "../Services/api";
import { useTranslation } from "react-i18next";
import { RefreshCcw, CalendarCheck, Clock, User, Hash } from "lucide-react";
import { FaMale, FaFemale, FaTransgenderAlt } from "react-icons/fa";
import Loader from './Loader';
import { toast } from "react-toastify";
export default function UnifiedForm({ onOtpVerified }) {
  const [showForm, setShowForm] = useState(false);
  const [prefillData, setPrefillData] = useState(null);
  const [isExistingUser, setIsExistingUser] = useState(false);
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState("registration");
  const [patientId, setPatientId] = useState(localStorage.getItem("patientId") || null);
  useEffect(() => {
    setIsExistingUser(Boolean(prefillData?.id));
  }, [prefillData]);
  const [patientList, setPatientList] = useState([]); // list of patients fetched
  const [showPatientPopup, setShowPatientPopup] = useState(false); // control modal
  const [loadingMessage, setLoadingMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [masterLists, setMasterLists] = useState(() => {
    try {
      const raw = localStorage.getItem("masterLists");
      return raw ? JSON.parse(raw) : null;
    } catch {
      return null;
    }
  });
const handleCancel = () => {
  const storedPatient = JSON.parse(localStorage.getItem("patient"));

  if (!storedPatient && !patientId) {
    toast.error(t("Please select a patient")); 
    return;
  }

  setShowPatientPopup(false);
};
  useEffect(() => {
    const storedData = JSON.parse(localStorage.getItem("patient"));
    setPrefillData(storedData);
  }, []);
  useEffect(() => {
    // Listen for "showPatientPopup" event from App dropdown
    const handleShowPatientPopup = (e) => {
      const patients = e.detail || [];
      if (patients.length > 0) {
        setPatientList(patients);
        setShowPatientPopup(true);
      }
    };

    window.addEventListener("showPatientPopup", handleShowPatientPopup);
    return () => window.removeEventListener("showPatientPopup", handleShowPatientPopup);
  }, []);


  const handleOtpSuccess = async (_notes, phone) => {
    try {
      setLoadingMessage("Loading Patients...");
      setLoading(true);
      const res = await fetchPatientByPhone(phone);
      const patients = res?.patients || [];

      if (patients.length === 0) {
        setPrefillData(null);
        localStorage.setItem("otpVerified", "true");
        setShowForm(true);
        if (onOtpVerified) onOtpVerified(null);
        return;
      }

      localStorage.setItem("patients", JSON.stringify(patients));

      if (patients.length === 1) {
        selectPatient(patients[0]);
      } else {
        setPatientList(patients);
        setShowPatientPopup(true);
      }

      if (onOtpVerified) onOtpVerified();
    } catch (err) {
      console.error("Patient lookup error:", err);
      setPrefillData(null);
    } finally {
      localStorage.setItem("otpVerified", "true");
      setShowForm(true); // render the form immediately
                  setLoading(false);

    }
  };
  const onBookingSuccess = () => {
    console.log("Switching to bookings tab");
    setActiveTab("bookings");
  };


  const selectPatient = (patient) => {
    localStorage.setItem("patient", JSON.stringify(patient));
    localStorage.setItem("patientId", patient?.id);
    setPatientId(patient?.id);
    setPrefillData(patient);
    setActiveTab("registration");
    setShowPatientPopup(false);

    // Now continue
    localStorage.setItem("otpVerified", "true");
    setShowForm(true);
    if (onOtpVerified) onOtpVerified();
  };


  console.log("Existing User", isExistingUser);
  console.log("prefillData", prefillData);
  const otpVerified = localStorage.getItem("otpVerified") === "true";

  return (
    <div className="relative min-h-screen font-sans bg-gradient-to-br from-blue-200 via-cyan-200 to-teal-200 dark:from-gray-900 dark:via-gray-800 dark:to-gray-700">
      {loading && <Loader message={loadingMessage} />}

      {/* Watermark */}
      <img
        src="/Images/TriloLogo_TRSP.png"
        alt="Watermark"
        className="pointer-events-none select-none absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 opacity-20 z-0 w-[70%] max-w-[500px]"
        style={{ userSelect: "none" }}
      />

      {/* Main content */}
      <div className="relative  max-w-4xl mx-auto p-4 md:p-6 space-y-6">

        {/* OTP Step */}
        {!otpVerified && <OTPVerification mode="register" onSuccess={handleOtpSuccess} />}

        {/* Tabs */}
        {otpVerified && (
          <div className="bg-white dark:bg-gray-800 rounded-2xl shadow-md p-4 md:p-6 space-y-4 transition-colors duration-300 relative overflow-visible">
            {/* Sliding Tabs */}
            <div className="relative w-full max-w-md mx-auto bg-gray-200 dark:bg-gray-700 rounded-full p-1 mb-4">
              <div
                className={`absolute top-1 left-1 h-[calc(100%-0.5rem)] w-1/2 bg-blue-500 rounded-full shadow transition-all duration-300`}
                style={{ transform: activeTab === "bookings" ? "translateX(100%)" : "translateX(0%)" }}
              />
              <div className="relative flex">
                <button
                  className={`flex-1 text-center py-2 rounded-full transition-all duration-300 ${activeTab === "registration" ? "text-white font-semibold" : "text-gray-700 dark:text-gray-300"
                    }`}
                  onClick={() => setActiveTab("registration")}
                >
                  {t("tabs.registration")}
                </button>
                <button
                  className={`flex-1 text-center py-2 rounded-full transition-all duration-300 ${activeTab === "bookings" ? "text-white font-semibold" : "text-gray-700 dark:text-gray-300"
                    }`}
                  onClick={() => setActiveTab("bookings")}
                >
                  {t("tabs.myBookings")}
                </button>
              </div>
            </div>

            {/* Forms / Bookings */}
            <div className="relative z-10">
              {activeTab === "registration" && (
                <PatientForm
                  prefillData={prefillData}
                  masterLists={masterLists}
                  onPatientRegistered={(id, data) => {
                    setPatientId(id);
                    setPrefillData(data);
                    localStorage.setItem("patientId", id);
                    localStorage.setItem("patient", JSON.stringify(data));
                  }}
                  onBookingSuccess={() => setActiveTab("bookings")}
                />
              )}
              {activeTab === "bookings" && isExistingUser && patientId && (
                <BookingsTab patientId={patientId} />
              )}
            </div>
          </div>
        )}

        {/* Patient Popup */}
        {showPatientPopup && (
          <div className="fixed inset-0 z-[9999] flex items-center justify-center
                bg-black/40 backdrop-blur-sm p-4">
            <div className="bg-gradient-to-br from-blue-50 via-cyan-50 to-teal-50
                  dark:from-gray-900/95 dark:via-gray-800/95 dark:to-gray-700/95
                  border border-blue-200 dark:border-gray-600
                  p-5 rounded-3xl shadow-2xl w-full max-w-md max-h-[90vh] overflow-auto
                  animate-fadeIn">
              {/* Header */}
              <h2 className="text-xl font-bold mb-6 text-center
                 text-blue-800 dark:text-cyan-400 tracking-wide">
                {t("personal.selectPatientHeader")}
              </h2>

              {/* Patient List */}
              <div className="grid grid-cols-1 gap-4">
                {patientList.map((p) => {
                  const formattedDob = new Date(p.dob).toLocaleDateString("en-GB");
                  return (
                    <div
                      key={p.id}
                      onClick={() => selectPatient(p)}
                      className="relative p-4 rounded-2xl bg-white/95 dark:bg-gray-800/90
                         border border-indigo-100 dark:border-indigo-700
                         shadow-md hover:shadow-xl hover:scale-[1.03]
                         transition-all cursor-pointer group overflow-hidden"
                    >
                      {/* Accent Bar */}
                    {/* Accent bar matching app theme */}
<div className="absolute left-0 top-0 h-full w-1.5 rounded-l-2xl
     bg-gradient-to-b from-blue-500 via-cyan-400 to-teal-400" />


                      {/* Patient Details */}
                      <div className="flex justify-between items-center mb-2">
                        <span className="font-semibold text-gray-700 dark:text-gray-200 flex items-center gap-1 text-sm sm:text-base">
                          <Hash size={16} /> {p.patientId}

                        </span>
                       <div
                                               className="inline-flex items-center justify-center rounded-full px-2 py-2 mt-1"
                                               style={{
                                                 backgroundColor:
                                                   p.gender === "Male"
                                                     ? "#DBEAFE"
                                                     : p.gender === "Female"
                                                       ? "#FECACA"
                                                       : "#E5E7EB",
                                                 lineHeight: 1,
                                               }}
                                             >
                                               {p.gender === "Male" ? (
                                                 <FaMale className="text-blue-700 w-4 h-4" />
                                               ) : p.gender === "Female" ? (
                                                 <FaFemale className="text-red-600 w-4 h-4" />
                                               ) : (
                                                 <FaTransgenderAlt className="text-gray-600 w-4 h-4" />
                                               )}
                                               <span className="ml-1 text-xs font-semibold text-gray-800 whitespace-nowrap">
                                                 {p.gender === "Male"
                                                   ? "Male"
                                                   : p.gender === "Female"
                                                     ? "Female"
                                                     : "Other"}
                                               </span>
                                             </div>

                      </div>

                      <div className="flex flex-col gap-1 text-xs sm:text-sm">
                        <p className="flex items-center gap-2 text-gray-700 dark:text-gray-200">
                          <span className="w-5 h-5 flex items-center justify-center">
                            <User size={16} />
                          </span>
                          <span className="font-medium">{t("personal.fullName")}:</span> {p.salutation} {p.name}
                        </p>

                        <p className="flex items-center gap-2 text-gray-700 dark:text-gray-200">
                          <span className="w-5 h-5 flex items-center justify-center">
                            <CalendarCheck size={16} />
                          </span>
                          <span className="font-medium"> {t("personal.dob")}:</span> {formattedDob}
                        </p>
                      </div>
                    </div>
                  );
                })}
              </div>

              {/* Cancel Button */}
              <button
  className="mt-6 w-full py-3 rounded-xl font-semibold text-white
     bg-gradient-to-r from-blue-500 to-cyan-500
     hover:from-blue-600 hover:to-cyan-600
     shadow-lg hover:shadow-xl transition-all duration-300"
  onClick={handleCancel}
>
  {t("patientSelector.cancel")}
</button>

            </div>
          </div>
        )}

      </div>
    </div>

  );
}
